export {
  allocateVariationSequenceCodePoints,
  EXTENSION_FONT_FAMILY_PRIORITY_LIST,
  FONT_FAMILY_PRIORITY_LIST,
  HANIVERSE_COMPOSITE_FONT_FAMILY,
  HANIVERSE_COMPOSITE_LATIN_FACE_ASCII_RANGE,
  HANIVERSE_COMPOSITE_TC_FONT_FAMILY,
  UNMAPPED_FONT_SENTINEL,
  VARIATION_SEQUENCE_CODE_POINT_START,
  VARIATION_SEQUENCE_FONT_FAMILY_LIST,
  isExtensionFontFamily,
  isGraphemeFontFamily,
  isHanCompositeLatinFaceText,
  isVariationSequenceFontFamily,
  leadingGraphemeUnit,
  normalizeFontFamily,
  variationSequenceDisplayText,
  type ExtensionFontFamily,
  type GraphemeFontFamily,
  type HanCompositeFontFamily,
  type SupportedFontFamily,
  type VariationSequenceFontFamily,
} from "#font-families";
export {
  getGraphemeFontFamilies,
  getGraphemeRender,
  getUnmappedCharacters,
  getVariationSequenceCodePoints,
  graphemeFonts,
  resolveGraphemeFontFamily,
  type GraphemeFontsData,
} from "#resolve-grapheme-font-family";
